import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';

@Injectable({
  providedIn: 'root'
})
export class WikiService {

  constructor(private apiService: ApiBaseService) { }

  async saveWikiArticle(payload: any): Promise<any> {
    return this.apiService.httpRequest('WikiService/SaveWikiArticle', payload, true, true);
  }

  async getWikiArticles(payload: any): Promise<any> {
    return this.apiService.httpRequest('WikiService/GetWikiArticles', payload, true, true);
  }

  async getWikiArticle(payload: any): Promise<any> {
    return this.apiService.httpRequest('WikiService/GetWikiArticle', payload, true, true);
  }

  async deleteWikiArticle(payload: any): Promise<any> {
    return this.apiService.httpRequest('WikiService/DeleteWikiArticle', payload, true, true);
  }

  async getWikiArticleIdByHeaderId(payload: any): Promise<any> {
    return this.apiService.httpRequest('WikiService/GetWikiArticleIdByHeaderId', payload, true, true);
  }
}